















import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";
import CryptoCompareService from "@/services/crypto-compare";

@Component({
  computed: {
    ...mapGetters("ui", ["nightMode"]),
    ...mapGetters("currency", { currencyName: "name" }),
    ...mapGetters("network", ["currencies"]),
  },
})
export default class HeaderCurrenciesMobile extends Vue {
  private nightMode: boolean;
  private currencyName: string;
  private currencies: string[];

  private async setCurrency(currency: string, symbol: string) {
    this.$store.dispatch("ui/setHeaderType", null);

    const rate = await CryptoCompareService.price(currency);
    this.storeCurrency(currency, rate!, symbol);
  }

  private storeCurrency(currency: string, rate: number, symbol: string) {
    this.$store.dispatch("currency/setName", currency);
    this.$store.dispatch("currency/setRate", rate);
    this.$store.dispatch("currency/setSymbol", symbol);
  }
}
